<div class="modal-header">
  <h4 class="modal-title header-13">{{ title }}</h4>
  <button
    type="button"
    class="accello-icon-btn"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img src="assets/images/virtusa-icons/close.svg" alt="close" />
  </button>
</div>

<!-- Process logs + animated gradient loader -->
<div class="modal-body process-loader-body p-4" *ngIf="isProcessing">
  <div class="process-error-banner mb-3" *ngIf="processIsError && processErrorMessage">
    <span class="process-error-label">Action Required:</span>
    <span class="process-error-message">{{ processErrorMessage }}</span>
  </div>

  <app-process-logs-loader
    [logs]="processLogs"
    [statusLabel]="processStatusLabel"
    [isActive]="processIsActive && !processIsError"
    [isError]="processIsError"
    [showLoader]="true"
  ></app-process-logs-loader>
</div>

<div class="modal-footer" *ngIf="isProcessing && processIsError">
  <button type="button" class="btn-accello-primary-light" (click)="activeModal.dismiss('cancel')">Cancel</button>
</div>

<!-- Validation content -->
<ng-container *ngIf="!isProcessing">
<div class="modal-body p-4">
  <!-- Validation Required Alert -->
  <div class="validation-alert d-flex flex-column justify-content-center align-items-start gap-3 p-3">
    <div class="d-flex gap-3 mx-2">
      <img
        src="assets/images/virtusa-icons/warning.svg"
        alt="Warning"
        class="alert-icon"
        width="16"
        height="16"
      />
      <div>
        <div class="alert-title">Validation Required</div>
        <div class="alert-message mt-1">
          Please click the Toggle button to proceed with validation.
        </div>
      </div>
    </div>
  </div>

  <!-- Validation Status -->
  <div class="validation-status mt-3">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <span class="status-label">Validation Status</span>
      <span class="status-counter">{{ validatedCount }} of {{ totalCount }} validated</span>
    </div>
    <div class="status-progress-track">
      <div
        class="status-progress-bar"
        [style.width.%]="totalCount > 0 ? (validatedCount / totalCount) * 100 : 0"
      ></div>
    </div>
  </div>

  <!-- Two-column layout -->
  <div class="content-layout py-3">

    <!-- Left: Tree Panel -->
    <div class="side-panel">
      <ng-container *ngFor="let group of treeNodes; let last = last">
        <div class="tree-group-row" (click)="toggleGroup(group)" (keydown)="toggleGroup(group)">
          <i class="bi" [ngClass]="isExpanded(group) ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
          <span class="group-name">{{ group.displayName }}</span>
          <div class="group-count-badge ms-auto d-flex align-items-center gap-1" *ngIf="group.count !== undefined">
            <img src="assets/images/virtusa-icons/document-icon.svg" alt="count" width="12" height="14" />
            <span class="count-value">{{ formatCount(group.count!) }}</span>
          </div>
        </div>
        <div class="tree-children" *ngIf="isExpanded(group) && group.children?.length">
          <div
            *ngFor="let child of group.children"
            class="tree-child-row"
            [class.selected]="selectedTreeNode?.id === child.id"
            (click)="selectNode(child); $event.stopPropagation()"
            (keydown)="selectNode(child); $event.stopPropagation()"
          >
            {{ child.displayName }}
          </div>
        </div>
        <hr class="group-divider" *ngIf="!last" />
      </ng-container>
    </div>

    <!-- Right: Panel -->
    <div class="right-panel">
      <div class="items-list">
        <div
          *ngFor="let item of nodeContents"
          class="item-card"
          [class.item-expanded]="item.expanded"
        >
          <!-- Row -->
          <div class="item-row" [class.pb-0]="item.url">
            <span class="item-name">{{ item.name }}</span>
            <span class="validated-badge" *ngIf="item.validated">Validated</span>
            <div class="item-controls ms-auto d-flex align-items-center gap-2">
              <div class="form-check form-switch m-0">
                <input
                  class="form-check-input item-toggle"
                  type="checkbox"
                  [(ngModel)]="item.enabled"
                  (ngModelChange)="item.validated = $event"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                />
              </div>
              <button class="item-action-btn" (click)="toggleExpansion(item)">
                <i class="bi" [ngClass]="item.expanded ? 'bi-dash-lg' : 'bi-plus-lg'"></i>
              </button>
            </div>
          </div>
          <!-- Item URL -->
          <div class="item-url text-muted small" *ngIf="item.url">{{ item.url }}</div>
          <!-- Expandable table -->
          <div class="item-table-wrap p-3" *ngIf="item.expanded && item.fields?.length">
            <app-zorro-table
              [columns]="tableColumns"
              [data]="item.fields"
              [hideTopBottomLines]="true"
              [hideVerticalBorder]="true"
            ></app-zorro-table>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn-accello-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
  <button type="button" class="btn-accello-primary-light" (click)="activeModal.close('save')" [disabled]="totalCount === 0 || validatedCount < totalCount">Save</button>
</div>
</ng-container>
